// @flow
import Partners from 'components/hub/Partners';
import { connect } from 'react-redux';

import type { StateType } from 'types/Actions';
import type { StateProps } from 'components/hub/Partners';

export default connect(
  (state: StateType): StateProps => ({
    partners: state.settingsState.partenaires,
    partnersLink: state.settingsState.partenaires_page,
    partenaires_une_titre: state.settingsState.partenaires_une_titre,
    partenaires_une_description: state.settingsState.partenaires_une_description,
  }),
)(Partners);
